(function () {
  'use strict';
  const experiment = 'smart_refine_v1';
  function assign(enabled) {
    if (!enabled) return 'off';
    const params = new URLSearchParams(location.search);
    if (params.has('sinama') && ['guided', 'control'].includes(params.get('refine'))) return params.get('refine');
    try {
      const key = 'wam_refine_experiment_v1';
      const stored = localStorage.getItem(key);
      if (['guided', 'control'].includes(stored)) return stored;
      const variant = crypto.getRandomValues(new Uint32Array(1))[0] % 2 ? 'guided' : 'control';
      localStorage.setItem(key, variant);
      return localStorage.getItem(key) === variant ? variant : 'unassigned';
    } catch (_) { return 'unassigned'; }
  }
  function create(options) {
    const { root, track } = options;
    const list = root.querySelector('[data-refine-list]');
    const status = root.querySelector('[data-refine-status]');
    const more = root.querySelector('[data-refine-more]');
    const apply = root.querySelector('[data-refine-apply]');
    const keep = root.querySelector('[data-refine-keep]');
    const manual = root.querySelector('[data-refine-manual]');
    const cache = new Map();
    const exposed = new Set();
    let designId = '', version = 0, selected = null, expanded = false, suggestions = [], busy = false;
    function draw() {
      list.replaceChildren();
      suggestions.forEach((item, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'wam-refine__option';
        button.dataset.testid = 'refine-option'; button.hidden = index >= 3 && !expanded;
        button.setAttribute('aria-pressed', String(selected?.id === item.id));
        const title = document.createElement('span'); title.className = 'wam-refine__title'; title.textContent = item.title;
        const detail = document.createElement('span'); detail.className = 'wam-refine__detail'; detail.textContent = item.detail;
        button.append(title, detail); button.disabled = busy;
        button.addEventListener('click', () => {
          selected = selected?.id === item.id ? null : item;
          for (const b of list.children) b.setAttribute('aria-pressed', String(b === button && Boolean(selected)));
          apply.disabled = !selected || busy;
          track(selected ? 'wam_oneri_secildi' : 'wam_oneri_secimi_kaldirildi', {tasarim_id:designId,oneri_id:item.id});
        });
        list.append(button);
      });
      more.hidden = suggestions.length <= 3;
      more.textContent = expanded ? 'Show fewer' : 'More ideas (' + (suggestions.length - 3) + ')';
      more.setAttribute('aria-expanded',String(expanded));
      apply.hidden = !suggestions.length; apply.disabled = !selected || busy;
      apply.textContent = busy ? 'Working…' : 'Apply change';
    }
    more.addEventListener('click', () => {expanded = !expanded; draw();});
    manual.addEventListener('click', () => options.onManual());
    keep.addEventListener('click', () => {
      track('wam_oneri_tasarimi_koru_tiklandi',{tasarim_id:designId}); options.onKeep();
    });
    apply.addEventListener('click', async () => {
      if (!selected || busy) return;
      const item = selected, id = designId;
      busy = true; draw();
      track('wam_oneri_uygula_tiklandi',{tasarim_id:id,oneri_id:item.id});
      try { await options.onApply(item.instruction,id); }
      finally { busy = false; draw(); }
    });
    async function show(design) {
      if (!design?.id) return;
      if (options.canRefine && !options.canRefine()) {
        ++version; designId = design.id; selected = null; suggestions = []; draw();
        root.hidden = false; root.dataset.designId = design.id; root.removeAttribute('aria-busy'); manual.hidden = true;
        status.textContent = 'You have reached the revision limit. Choose one of your saved designs.';
        return;
      }
      manual.hidden = false;
      if (design.id === designId) return;
      const id = design.id, current = ++version;
      designId = id; selected = null; expanded = false; suggestions = []; draw();
      root.hidden = false; root.dataset.designId = id;
      status.textContent = 'Finding ideas for this design…'; root.setAttribute('aria-busy','true');
      if (!exposed.has(id)) { exposed.add(id); track('wam_oneri_deney_goruldu',{tasarim_id:id}); }
      let request = cache.get(id);
      if (!request) {
        request = fetch(options.api + '/api/design/' + encodeURIComponent(id) + '/suggestions', {
          method:'POST', signal:AbortSignal.timeout(50_000),
        }).then(async response => response.ok ? response.json() : {status:response.status === 429 ? 'capacity_limited' : 'network_error',suggestions:[]}).catch(() => ({status:'network_error',suggestions:[]}));
        cache.set(id,request);
        void request.then(result => { if (result?.status !== 'ready' && cache.get(id) === request) cache.delete(id); });
      }
      const result = await request;
      // Old replies must never suggest an edit to the newly selected design.
      if (current !== version || id !== designId) return;
      root.removeAttribute('aria-busy');
      suggestions = result?.status === 'ready' && Array.isArray(result.suggestions)
        ? result.suggestions.filter(item => item && typeof item.id === 'string' && /^[a-z0-9_-]{1,20}$/i.test(item.id) &&
          typeof item.title === 'string' && item.title.length <= 48 && typeof item.detail === 'string' && item.detail.length <= 120 &&
          typeof item.instruction === 'string' && item.instruction.length <= 300).slice(0,5) : [];
      status.textContent = suggestions.length ? 'Pick one change to try.'
        : result?.status === 'ready' ? 'Keep this design, or write a change of your own.'
        : 'Ideas are unavailable. You can still write a change or choose this design.';
      draw();
      track(suggestions.length ? 'wam_oneriler_hazir' : 'wam_oneriler_bos',{tasarim_id:id,adet:suggestions.length,durum:result?.status || 'unavailable'});
    }
    const orderObserver = new IntersectionObserver(entries => {
      const orderVisible = entries.some(entry => entry.isIntersecting);
      root.classList.toggle('wam-refine--order-visible',orderVisible);
    });
    if (options.order) orderObserver.observe(options.order);
    return {show};
  }
  window.WamSmartRefine = {assign, create, experiment};
})();
